export const TAMIL = {
  'language': 'Tamil',
  'amount': {
    'placeholder': 'நீங்கள் எவ்வளவு உயர்த்த விரும்புகிறீர்கள்? ',
    'error': {
      'min': 'குறைந்தபட்ச இலக்கு தொகை ₹ 2000!',
      'max': 'அதிகபட்ச இலக்கு தொகை ₹ 5 கோடி ',
      'required': 'குறைந்தபட்ச இலக்கு தொகை ₹ 2000!'
    },
    'hint': 'குறைந்தபட்சம் ₹ 2000 ',
    'popover': {
      'title': 'இலக்கு ',
      // tslint:disable-next-line:max-line-length
      'desc': `உங்கள் இலக்கு தொகையை எப்பொழுதும் நீங்கள் மாற்றலாம்.தொடங்குவது என்று உங்களுக்கு தெறியவில்லை என்றால், பெரும்பாலான பிரசாரங்கள் ₹ 1,00,000 இலக்காக கொண்டிருக்கும் `,
      'eg': 'இலக்கு எப்பொழுதும் ₹ 2000 க்கும் மேலாக இருக்க வேண்டும் '
    }
  },
  'title': {
    'placeholder': 'நிதிதிரட்டல் தலைப்பு',
    'error': {
      'minlength': 'நிதி திரட்டலின் தலைப்பு 5-75 எழுத்துக்களுக்குள் இருக்க வேண்டும்',
      'maxlength': 'நிதி திரட்டலின் தலைப்பு 5-75 எழுத்துக்களுக்குள் இருக்க வேண்டும்',
      'required': 'நிதி திரட்டலின் தலைப்பு 5-75 எழுத்துக்களுக்குள் இருக்க வேண்டும்'
    },
    'popover': {
      'title': 'இதுவே உங்களது நிதிதிரட்டல் தலைப்பு',
      'desc': 'எ.கா. தாழ்த்தப்பட்ட பெண் குழந்தைளை மேம்படுத்த எனக்கு உதவுங்கள் அல்லது புற்றுநோயை எதிர்த்து போராட எங்கள் ஆஸ்தாவுக்கு உதவுங்கள் '
    },
    'medicalDocTitle': 'மருத்துவ ஆவணங்களச் சேர்க்கவும் '
  },
  'relation': {
    'placeholder': 'நீங்கள் யாருக்காக நிதி திரட்டுகிறீர்கள்?',
    'popover': {
      'title': 'நீங்கள் யாருக்காக நிதி திரட்டுகிறீர்கள்',
      'desc': 'எ.கா. தனிப்பட்ட, படைப்பாளி அல்லது என்ஜிஓவுக்கான பிரச்சாரத்தை நீங்கள் உருவாக்கலாம்'
    },
    'error': {
      'required': 'தயவு செய்து சரியான விருப்பத்தை தேர்ந்தெடுக்கவும் '
    }
  },
  'name': {
    'placeholder': `நோயாளியின் முழுப் பெயர் `,
    'error': {
      'maxlength': 'பெயர் 50 எழுத்துக்களுக்கு மிகாமல் இருக்க வேண்டும்',
      'pattern': 'தயவு செய்து சரியான பெயரை உள்ளிடவும்',
      'required': 'தயவு செய்து சரியான பெயரை உள்ளிடவும்'
    },
    'hint': 'உங்கள் ஆதார் அட்டையில் குறிப்பிட்டுள்ளபடி பெயர்',
    'popover': {
      'title': `நோயாளியின் பெயர்`,
      'desc': 'தயவு செய்து நோயாளியின் முழுப் பெயரை ஆதார் அட்டையில் குறிப்பிட்டுள்ளபடி உள்ளிடவும்'
    }
  },
  'patient': {
    'placeholder': `நோயாளியின் முழுப் பெயர் `,
    'error': {
      'maxlength': 'பெயர் 50 எழுத்துக்களுக்கு மிகாமல் இருக்க வேண்டும்',
      'minlength': 'தயவு செய்து நோயாளியின் முழுப் பெயரை ஆதார் அட்டையில் குறிப்பிட்டுள்ளபடி உள்ளிடவும்',
      'pattern': 'தயவு செய்து சரியான பெயரை உள்ளிடவும்',
      'required': 'தயவு செய்து சரியான பெயரை உள்ளிடவும்'
    },
    'hint': 'உங்கள் ஆதார் அட்டையின் படி பெயர்',
    'popover': {
      'title': `நோயாளியின் பெயர்`,
      'desc': 'தயவு செய்து நோயாளியின் முழுப் பெயரை ஆதார் அட்டையில் குறிப்பிட்டுள்ளபடி உள்ளிடவும்'
    }
  },
  'age': {
    'placeholder': `நோயாளியின் வயது`,
    'error': {
      'required': 'தயவு செய்து சரியான வயதுக் குழுவை உள்ளிடவும்'
    }
  },
  'hosptialisationStatus': {
    'placeholder': `மருத்துவமனையில் சேர்க்கும் நிலை`,
    'error': {
      'required': 'புலம் தேவை '
    }
  },
  'uploadImg': {
    'error': {
      'required': 'புலம் தேவை',
      'pattern': 'சரியான எண்ணை உள்ளிடவும்'
    }
  },
  'cause': {
    'placeholder': 'தயவு செய்து ஒரு காரணத்தை தேர்ந்தெடுக்கவும்',
    'popover': {
      'title': 'இது உங்களது காரணம்',
      'desc': 'இது எங்கள் இணையதளத்தில் உங்கள் நிதி திரட்டலைக் கண்டுபிடிக்க ஒத்த எண்ணம் கொண்ட, அன்பான மக்களுக்கு உதவும்'
    },
    'error': {
      'required': 'தயவு செய்து ஒரு காரணத்தை தேர்ந்தெடுக்கவும்'
    }
  },
  'survey': {
    'placeholder': 'எங்களைப் பற்றி நீங்கள் எப்படி கேள்விப்பட்டீர்கள்?',
    'error': {
      'required': 'புலம் தேவை '
    }
  },
  'end_date': {
    'placeholder': 'முடிவு தேதி',
    'error': {
      'minlength': 'நிதித்திரட்டல் முடிவு தேதி இன்றை விட பழையதாக இருக்க முடியாது!',
    },
    'popover': {
      'title': 'நிதி திரட்டலுக்கான முடிவு தேதி ',
      'desc': 'உங்களது நிதிதிரட்டல் இந்த தேதியில் முடியும் '
    }
  },
  'fundraiser_image': {
    'placeholder': 'நிதித்திரட்டல் உருவம்/வீடியோவை சேர்க்கவும்',
    'optional': '(விருப்பமானது)',
    'upload': 'பதிவேற்றவும்',
    'popover': {
      'title': 'நிதித்திரட்டல் உருவம்/வீடியோவை பதிவேற்றவும்',
      'desc': `இதுவே உங்கள் நிதிதிரட்டலின் முகம் ஆகும். சிறந்த புகைப்படம் நிதிதிரட்டலுக்கு மேலும் நிதி திரட்ட உதவும். உங்கள் நிதி திரட்டலை சிறப்பாக விவரிக்கும் பிக்சலேட் இல்லாத, உயர் தெளிவுத்திறன், தெளிவான படங்கள்/வீடியோக்களைச் சேர்க்கவும்.`,
      'eg': `சரியான அளவு: 750X435. அதுவே பெரிதானால், கவலை வேண்டாம், பதிவேற்றும்போது அதனை வெட்டிக்கொள்ளலாம்.`
    }
  },
  'beneficiary_image': {
    'placeholder': `நோயாளியின் உருவத்தை சேர்க்கவும்`,
    'popover': {
      'title': 'இந்த நபருக்குத் தான் நீங்கள் நிதி திரட்டப்போகிறீர்கள் ',
      'desc': `உருவத்தை சேர்ப்பதன் மூலம் நன்கொடையை 50% அதிகரிக்கலாம். திரட்டப்பட்ட நிதி இந்த பயனாளிக்கு செல்லும் என்பதைச் சரிபார்க்க நாங்கள் உங்களிடமிருந்து கூடுதல் தகவல்களைக் கோரலாம்`
    }
  },
  'short_description': {
    'placeholder': 'ஒரு சிறு விளக்கத்தை சேர்க்கவும்',
    'error': {
      'minlength': 'குறைந்தது 10 எழுத்துக்கள் தேவை',
      'maxlength': 'சிறு விளக்கம் 120 எழுத்துக்களுக்கு மிகாமல் இருக்க வேண்டும்'
    },
    'popover': {
      'title': 'உங்கள் நிதிதிரட்டலைப் பற்றி சுருக்கமாக விளக்கவும்',
      'desc': `120 எழுத்துக்களில் உங்கள் நிதிதிரட்டலுக்கான ஒரு சுருக்கமான விளக்கத்தை எழுதுங்கள்`,
      'eg': `எ.கா. ஆஸ்தாவுக்கு 8 வயதே ஆகிறது, தீவிர லிம்போப்லாஸ்டிக் லுகேமியாவுக்கு எதிராக போராட அவளுக்கு உதவுங்கள்`
    }
  },
  'description_story': {
    'placeholder':
      'உங்கள் காரணத்திற்காக நியாயம் செய்யும் மற்றும் ஆதரவாளர் நன்கொடை பொத்தானைக் கிளிக் செய்யும் வகையில் ஒரு கதையை எழுதவும்'
      + '\n\n இந்த வழிமுறைகளைப் பின்பற்றவும்:'
      + '\n* நீங்கள் யாருக்காக நிதி திரட்டுகிறீர்கள் என்பது பற்றி பேசுங்கள், அது நீங்களோ உங்களது அன்புக்குறியவரோ.'
      + '\n* நீங்கள் ஏன் நிதி திரட்டுகிறீர்கள் என்பதை விளக்கவும்.'
      + '\n* நீங்கள் ஆதரவாளர்களுக்கு வேண்டுகோள் விடுங்கள்.',
    'popover': {
      'title': 'உங்கள் நிதிதிரட்டலைப் பற்றி மேலும் கூறுங்கள்',
      'desc': 'உங்களின் கதையை சொல்லுங்கள்',
      'placeholder':
        `<div>• உங்கள் காரணத்திற்காக நியாயம் செய்யும் மற்றும் ஆதரவாளர் நன்கொடை பொத்தானைக் கிளிக் செய்யும் வகையில் ஒரு கதையை எழுதவும்.</div>
    <div>• நீங்கள் சிக்கிக்கொண்டால் சோர்வடைய வேண்டாம்.</div>
    <div>•  இந்த வழிமுறைகளைப் பின்பற்றவும்:</div>
    <div>• நீங்கள் யாருக்காக நிதி திரட்டுகிறீர்கள் என்பதைப் பற்றி பேசுங்கள், உங்களுக்காகவோ அல்லது உங்கள் அன்புக்குரியவரோ</div>
    <div>• நீங்கள் ஏன் நிதி திரட்டுகிறீர்கள் என்பதை விளக்கவும்.div>
    <div>• உங்கள் ஆதரவாளர்களிடம் முறையீடு செய்யுங்கள்.</div>
    <div>• இந்த காரணத்திற்காக ஒரு நிதி திரட்டலைத் தொடங்கியதை உங்கள் ஆதரவாளர்களுக்குத் தெரியப்படுத்துங்கள், அதனால் அவர்கள் ஒரு பங்களிப்பைச் செய்ய உந்துதல் பெறுவார்கள்.</div>
    <div>• தங்களது பணம் எங்கு செல்கிறது என்பதை அறிய உங்கள் ஆதரவாளர்களுக்கு அனைத்து விவரங்களையும் வழங்கவும்.</div>
    <div>• Word ஆவணத்திலிருந்து நேரடியாக தகவல்களை எடுப்பதைத் தவிர்க்கவும்.</div>`,
    }
  },
  'disease': {
    'label': 'வியாதி/மருத்துவ நிலை',
    'placeholder': 'உங்களின் மருத்துவ நிலையை இங்கே உள்ளிடவும் ',
    'error': {
      'required': 'தயவு செய்து ஒரு நோயை தேர்ந்தெடுக்கவும் '
    }
  },
  'hospital': {
    'label': 'மருத்துவமனை',
    'placeholder': 'உங்களது மருத்தவமனை பெயரை இங்கே உள்ளிடவும்',
    'error': {
      'required': 'தயவு செய்து ஒரு மருத்துவமனையை தேர்வு செய்யவும் '
    }
  },
  'ngo': {
    'placeholder': 'என்ஜிஓ பெயர்',
    'error': {
      'notFound': 'இந்த பெயரில் எந்த என்ஜிஓவும் காணப்படவில்லை'
    },
    'popover': {
      'title': 'என்ஜிஓ',
      'desc': 'என்ஜிஓ'
    }
  },
  'city': {
    'placeholder': 'உங்களது நகரத்தை உள்ளிடவும்',
    'popover': {
      'title': 'உங்களது நிதிதிரட்டல் நகரத்தை உள்ளிடவும்',
      'desc': 'இதுவே இந்த நிதித்திரட்டல் இயங்கும் நகரம் ஆகும்'
    }
  },
  'beneficiaryname': {
    'placeholder': 'பயனாளியின் பெயர்',
    'error': {
      'maxlength': 'பயனாளியின் பெயர் 50 எழுத்துகளுக்கு மிகாமல் இருக்க வேண்டும்',
      'pattern': 'தயவு செய்து சரியான பெயரை உள்ளிடவும்',
      'required': 'தயவுசெய்து பயனாளியை தேர்ந்தெடுக்கவும்'
    },
    'popover': {
      'title': 'நீங்கள் யாருக்காக திரட்டுகிறீர்களோ அவரின் பெயரை குறிப்பிடவும்',
      'desc': 'நீங்கள் யாருக்காக பணம் திரட்டுகிறீர்கள் என்பதை உங்கள் ஆதரவாளர்களுக்கு தெரிவிப்பது முக்கியம்'
    }
  },
  'names': {
    'placeholder': 'பெயர்',
    'hint': 'உங்கள் ஆதார் அட்டையின் படி பெயர்',
    'error': {
      'maxlength': 'அதிகபட்ச எழுத்து வரையறை மிஞ்சிவிட்டது',
      'pattern': 'தயவு செய்து சரியான பெயரை உள்ளிடவும்'
    },
  },
  'email': {
    'placeholder': 'மின்னஞ்சல் முகவரி',
    'error': {
      'email': 'சரியான மின்னஞ்சலை உள்ளிடவும்',
    },
  },
  'password': {
    'placeholder': 'கடவுச் சொல்லை உருவாக்கவும்',
    'error': {
      'minlength': 'தயவுசெய்து குறைந்தபட்சம் 8 எழுத்துக்களை உள்ளிடவும்',
      'pattern': 'குறைந்தபட்சம் 1 எண், 1 பெரிய எழுத்து மற்றும் 1 சிறிய எழுத்து தேவை'
    }
  },
  'mobile': {
    'placeholder': 'மொபைல்',
  },
  'reward_title': {
    'placeholder': 'வெகுமதி தலைப்பு',
    'error': {
      'minlength': 'குறைந்தபட்சம் 5 எழுத்துக்கள் தேவை',
      'maxlength': 'வெகுமதி தலைப்பு 50 எழுத்துகளுக்கு மிகாமல் இருக்க வேண்டும்'
    },
    'popover': {
      'title': 'வெகுமதி தலைப்பை உள்ளிடவும்',
      'desc': 'கவர்ச்சியான வெகுமதி தலைப்பை இடவும்'
    }
  },
  'guardian_relations': {
    'Friend': {
      'Below 5 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '6 -10 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '11 - 17 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '18 - 30 years': 'நோயாளியின் எண் தேவைப்படுகிறது',
      '30 - 40 years': 'நோயாளியின் எண் தேவைப்படுகிறது',
      'Above 40 years': 'நோயாளியின் எண் தேவைப்படுகிறது'
    },
    'Friend\'s Family': {
      'Below 5 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '6 -10 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '11 - 17 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '18 - 30 years': 'நோயாளியின் எண் தேவைப்படுகிறது',
      '30 - 40 years': 'நோயாளியின் எண் தேவைப்படுகிறது',
      'Above 40 years': 'நோயாளியின் எண் தேவைப்படுகிறது'
    },
    'Colleague': {
      'Below 5 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '6 -10 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '11 - 17 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '18 - 30 years': 'நோயாளியின் எண் தேவைப்படுகிறது',
      '30 - 40 years': 'நோயாளியின் எண் தேவைப்படுகிறது',
      'Above 40 years': 'நோயாளியின் எண் தேவைப்படுகிறது'
    },
    'Relative': {
      'Below 5 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '6 -10 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '11 - 17 years': 'பாதுகாவலர் எண் தேவைப்படுகிறது',
      '18 - 30 years': 'நோயாளியின் எண் தேவைப்படுகிறது',
      '30 - 40 years': 'நோயாளியின் எண் தேவைப்படுகிறது',
      'Above 40 years': 'நோயாளியின் எண் தேவைப்படுகிறது'
    },
    'Legal ward': {
      '18 - 30 years': 'நோயாளியின் எண் தேவைப்படுகிறது',
      '30 - 40 years': 'நோயாளியின் எண் தேவைப்படுகிறது',
      'Above 40 years': 'நோயாளியின் எண் தேவைப்படுகிறது'
    }
  },
  'otp': {
    'placeholder': `ஓடிபி`,
    'error': {
      'required': 'ஓடிபியை உள்ளிடவும்'
    }
  },
  get_otp: 'OTP அனுப்பவும்',
  verify_mobile: 'மொபைல் எண்ணை சரிபார்க்கவும்',
  start_your_fundraiser: 'உங்கள் நிதித்திரட்டலை ஆரம்பிக்கவும்',
  change_easily: 'உங்கள் நிதிதிரட்டலில் எந்த நேரத்திலும் எளிதாக மாற்றங்கள் செய்யலாம்',
  tell_us_more: 'உங்கள் நிதிதிரட்டலைப் பற்றி மேலும் கூறுங்கள்',
  tellAboutFundraiser: 'உங்கள் நிதிதிரட்டலைப் பற்றி மேலும் கூறுங்கள் ',
  patientIsMy: 'நோயாளி எனது...',
  raising_funds_for: 'யாருக்காக நிதிதிரட்டுகிறீர்கள் ',
  ngo_charity: 'என்ஜிஓ/தொண்டு',
  qualification: 'உங்கள் கல்வித் தகுதி',
  occupation: 'உங்கள் வேலைவாய்ப்பு நிலை',
  purposeText: 'நோக்கம்',
  other: 'மற்ற',
  iAgree: 'நான் கேட்டோவை ஒப்புக்கொள்கிறேன்',
  serviceAgreement: 'சேவை ஒப்பந்தம்',
  and: 'மற்றும்',
  change_purpose: 'மாற்றத்தின் நோக்கம்',
  save_and_continue: 'சேமித்து தொடரவும்',
  ketto_zero_fee: 'Ketto வின் ஜீரோ பிளாட்பார்ம் கட்டணக்கொள்கை உங்களுக்கு அதிக நிதியை உறுதி செய்யும்',
  is_patient_admitted: 'நோயாளி மருத்துவமனையில் அனுமதிக்கப்பட்டுள்ளாரா?',
  tell_us_about_patient: `நோயாளியைப் பற்றி சொல்லவும் `,
  medical_condition: `வியாதி/மருத்துவ நிலை `,
  guardian_no: `பாதுகாவலர் மொபைல் எண் `,
  patient_no: 'நோயாளியின் மொபைல் எண் ',
  yes: `ஆம்`,
  no: `இல்லை `,
  optional: '(விருப்பமானது)',
  story_form_title: `நீங்கள் ஏன் நிதிதிரட்டலை நடத்துகிறீர்கள் என்பது பற்றிய கதையை சொல்லுங்கள்  `,
  help_me_write_this: `நான் இதனை எழுத உதவுங்கள் `,
  terms_of_use: `பயன்பாட்டு விதிமுறை`,
  privacy_policy: `தனியுரிமை கொள்கை`,
  plans_and_pricing: `திட்டங்கள் & விலை நிர்ணயம்`,
  choose_file: 'கோப்பை தேர்ந்தெடுக்கவும்',
  submit_for_approval: 'ஒப்புதலுக்கு சமர்ப்பிக்கவும்',
  exisiting_account: 'ஏற்கனவே கணக்கு உள்ளதா? ',
  login: 'உள்நுழை',
  next: 'அடுத்து',
  purpose: 'நிதிதிரட்டலுக்கான நோக்கம்',
  are_you_an_ngo: 'நீங்கள் ஒரு என்ஜிஓவா? ',
  apply_here: 'இங்கு விண்ணப்பிக்கவும்',
  get_assistance: 'உதவியைப் பெறுங்கள்',
  validPhNo: 'தயவு செய்து சரியான எண்ணை உள்ளிடவும்',
  back: 'திரும்ப',
  fieldRequired: 'புலம் தேவை',
  acknowledge: '"மேலே வழங்கப்பட்ட தகவல்கள் எனது அறிவு மற்றும் நம்பிக்கைக்கு ஏற்றவாறு உண்மை மற்றும் சரியானவை என்பதை நான் ஒப்புக்கொள்கிறேன் மற்றும் உறுதி செய்கிறேன் மேலும் மேற்கூறிய தகவல்கள் ஏதேனும் பொய்யானவை அல்லது தவறாக வழிநடத்தப்பட்டவை எனில் நான் பொறுப்பேற்க ஒப்புகொள்கிறேன். ஒழுங்குமுறை அதிகாரிகளுடன் பகிர்ந்து கொள்வதற்கு அல்லது சட்டத்தால் தேவைப்படக்கூடிய வகையில் அதை வெளிபடுத்த நான் இதன் மூலம் எனது ஒப்புதலை அளிக்கிறேன்"',
};
